export default __webpack_public_path__ + "static/media/asscher-reversed.8813b784.svg";